import React, { useEffect, useState } from 'react';
import MainHeader from '../../Layouts/Header/MainHeader';
import { Box, Stack } from '@mui/material';
import Title from '../../Components/UI/Title';
import NotFoundPageImage from '../../Layouts/NotFoundPageImage';

export default function NotFoundPage() {

  return (
    <>
      <MainHeader title="" />
      <Box sx={{ p: 2, width: '86%' }}>
        <NotFoundPageImage />
        <Title title="صفحه‌ای که دنبال آن بودید پیدا نشد!" hasIcon={false} />
      </Box>
      <Box sx={{ p: 2, width: '86%' }}>
        <Stack spacing={3} direction="column"></Stack>
      </Box>
    </>
  );
}
